import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c5d6b62&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.response.css?vue&type=style&index=0&id=6c5d6b62&prod&scoped=true&lang=css&external"
import style1 from "./assets/candidate.css?vue&type=style&index=1&id=6c5d6b62&prod&scoped=true&lang=css&external"
import style2 from "./index.vue?vue&type=style&index=2&id=6c5d6b62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d6b62",
  null
  
)

export default component.exports